import React, { useContext } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import WellPerformanceStore from "../wellperformance/store/WellPerformanceStore";
import { createContext } from "react";
import moment from "moment";
import { Skeleton } from "antd";
import { Observer } from "mobx-react-lite";

const wellPerformanceStoreCtx = createContext(WellPerformanceStore);

export const GasWellPerformanceChart = () => {
  const wellPerformanceStore = useContext(wellPerformanceStoreCtx);
  const plotData = wellPerformanceStore.plotData || [];
  const getSeriesData = (field) =>
    plotData.map((point) => {
      const value = Number(point?.[field]);
      return Number.isFinite(value) ? value : null;
    });

  return (
    <Observer>
      {() =>
        wellPerformanceStore.isIniatilizing ? (
          <div style={{ padding: "15px" }}>
            <Skeleton active />
            <Skeleton active />
            <Skeleton active />
          </div>
        ) : (
          <HighchartsReact
            highcharts={Highcharts}
            options={{
              chart: { zoomType: "xy" },
              credits: { enabled: true, text: "source: SPARS" },
              title: { text: `${wellPerformanceStore.selectedWell} Performance Plot`, align: "center" },
              xAxis: { categories: plotData.map((point) => point?.productionDate ? moment(point.productionDate).format("MM-Y") : ""), crosshair: true },
              yAxis: [
                { title: { text: "Cum. Gas Prod(Mscf)" }, opposite: true },
                { title: { text: "FTHP (psi)" } },
                { min: 0, max: 100, title: { text: "Water Cut (%)" }, opposite: true },
                { min: 0, title: { text: "Prod. GOR(scf/bbl)" } },
                { min: 0, max: 100, title: { text: "BSW" }, opposite: true },
              ],
              tooltip: { shared: true },
              legend: { layout: "horizontal", align: "center", verticalAlign: "bottom", backgroundColor: "#FFFFFF" },
              series: [
                { name: "FTHP", type: "spline", yAxis: 1, data: getSeriesData("fthp"), marker: { enabled: false }, color: "#d22d3a" },
                { name: "Water Cut (%)", type: "spline", yAxis: 2, data: getSeriesData("waterCut"), marker: { enabled: false }, color: "#034f84" },
                { yAxis: 3, name: "Cum. Gas.Prod", type: "spline", color: "#92b558", data: getSeriesData("cumGas"), marker: { enabled: false } },
                { name: "Producing GOR (scf/d)", color: "#766f57", type: "spline", data: getSeriesData("producingGOR"), marker: { enabled: false } },
                { yAxis: 2, name: "BSW (%)", color: "#766f57", type: "spline", data: getSeriesData("bsw"), marker: { enabled: false } },
              ],
            }}
          />
        )
      }
    </Observer>
  );
};